/* eslint-disable import/prefer-default-export */
import flatpickr from 'flatpickr';

export function debounce(callback, time) {
  let interval;
  return (...args) => {
    clearTimeout(interval);
    interval = setTimeout(() => {
      interval = null;
      // eslint-disable-next-line
      callback(...args);
    }, time);
  };
}

/*
 * Formats number to be displayed in number of thousands, millions or billions
 *
 * based on:
 * https://stackoverflow.com/questions/12900332/how-do-i-round-millions-and-thousands-in-javascript
 */

/*
****** NOTES: ******
- 1230 returns as 1K instead of 1.23K
*/
export function formatNumber(num) {
  // Nine Zeroes for Billions
  // eslint-disable-next-line no-nested-ternary
  return Math.abs(num) >= 1.0e9
    ? `${Math.round(num / 1.0e9)}B`
    : // Six Zeroes for Millions
    // eslint-disable-next-line no-nested-ternary
    Math.abs(num) >= 1.0e6
    ? `${Math.round(num / 1.0e6)}M`
    : // Three Zeroes for Thousands
    Math.abs(num) >= 1.0e3
    ? `${Math.round(num / 1.0e3)}K`
    : Math.abs(num);
}

export function uuidv4() {
  let uuid = '';
  let i;
  let random;

  // eslint-disable-next-line no-plusplus
  for (i = 0; i < 32; i++) {
    // eslint-disable-next-line no-bitwise
    random = (Math.random() * 16) | 0;

    if (i === 8 || i === 12 || i === 16 || i === 20) {
      uuid += '-';
    }
    // eslint-disable-next-line
    uuid += (i === 12 ? 4 : i === 16 ? (random & 3) | 8 : random).toString(16);
  }
  return uuid;
}

export function isObjectEmpty(object) {
  return Object.entries(object).length === 0 && object.constructor === Object;
}

/*
 * Generates a random id value (that you can append to a string).
 */
export function randomizeId(string = '') {
  return `${string}${Math.floor(Math.random() * 100000000000000000000)}`;
}

export function objectHasOwnProperties(object, ...args) {
  return args.every((argument) =>
    Object.prototype.hasOwnProperty.call(Object(object), `${argument}`)
  );
}

/**
 * Formats a date object to the specified string format. Currently using Flatpickr's static method.
 * Check available formatting tokens here: https://flatpickr.js.org/formatting/
 *
 * @param {Date} date The date to be formatted.
 * @param {string} format The format to be used.
 */
export function formatDate(date, format) {
  if (!(date instanceof Date)) return null;
  return flatpickr.formatDate(date, format);
}
